import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { Notification } from "../../../api";

export const notificationKeys = {
  all: () => ["notifications"]
};

export function useGetNotifications(paramsString, config) {
  const { callApi } = useAuth();
  return useQuery([...notificationKeys.all(), paramsString],
    () => callApi(Notification.getNotifications, paramsString), config);
}

export function useUpdateNotificationStatus(config) {
  const { callApi } = useAuth();
  return useMutation((ids) => {
    return callApi(Notification.updateNotificationStatus, ids);
  }, config);

}